import { Loading } from "src/components/utils/Loading";
import { useScoreDetailContext } from "src/context/ScoreDetail/useScoreDetailContext";
import { UserProperty } from "src/context/Property/Builder/PropertyBuilder";
import { DrilldownState } from "src/context/ScoreDetail/useDrilldown";
import { ModalData } from "src/components/ScoreDetail/PropertyModal/PropertyModal";
import { ScoreDetailChartBox } from "src/components/ScoreDetail/Chart";
import { ChartMode, ScoreDetailChartData } from "src/components/ScoreDetail/Chart/chart.types";

type ByPropertiesProps = {
    headingId: number;
    subheadingId?: number;
    propertyId: number;
    openModal: (property: ModalData) => void;
    mode: ChartMode;
};
export const ByProperties = (props: ByPropertiesProps) => {
    const { headingId, subheadingId, propertyId, mode, openModal } = props;

    const { scoreDetailBuilder, drilldownState } = useScoreDetailContext();
    if (scoreDetailBuilder === undefined) {
        // This should be deleted
        return <Loading />;
    }

    const _property = scoreDetailBuilder.getByPropertyId({
        headingId,
        subheadingId,
        propertyId,
    });
    if (_property === null) return null;
    const { property } = _property;

    const chartData = serializeProperty({
        property,
        drilldown: drilldownState.drilldown,
        openModal,
        mode,
    });
    if (chartData === null) return null;

    const total: ScoreDetailChartData | null =
        property.score !== null ?
            {
                title: "Total",
                score: property.score,
            }
        :   null;

    return <ScoreDetailChartBox data={chartData} total={total} mode={mode} />;
};

type SerializePropertyOptions = {
    property: UserProperty<unknown>;
    drilldown: (item: DrilldownState) => void;
    openModal: (property: ModalData) => void;
    mode: ChartMode;
};

const serializeProperty = (options: SerializePropertyOptions): ScoreDetailChartData[] | null => {
    const { property, openModal, mode } = options;
    if (property.type === "value") {
        // Not meant to be here
        return null;
    }

    if (property.type === "group") {
        const items: ScoreDetailChartData[] = property.content.flatMap((groupProperty) => {
            const value = groupProperty.score?.value;
            if (!value) return [];

            const score = groupProperty.score;
            if (score === null) return [];

            const action = mode !== "distribution" ? undefined : () => openModal(property);

            const comparisonItem: ScoreDetailChartData = {
                title: groupProperty.property.name ?? groupProperty.property.title ?? "",
                score: score,
                action,
            };
            return [comparisonItem];
        });
        return items;
    }

    if (property.type === "multi") {
        const items: ScoreDetailChartData[] = property.scoreBySubproperty.flatMap((item) => {
            const value = item.score?.value;
            if (!value) return [];
            const score = item.score;
            if (score === null) return [];

            const action = mode !== "distribution" ? undefined : () => openModal(property);

            const comparisonItem: ScoreDetailChartData = {
                title: item.name ?? item.title,
                score: score,
                action,
            };
            return [comparisonItem];
        });
        return items;
    }

    return null;
};
